<template>
  <div>
    <div class="a-vg-c--logo">
    </div>
    <div :class="closeButtonClass"  @click="toggleLeftMenu">
      <image-svg :imageClass="iconClass" :imageName="closeImage"/>
    </div>
  </div>
</template>

<script>
import NumberFormat from '@/mixins/NumberFormat'
import VDogHelper from '@/mixins/VDogHelper'
import ImageSVG from '@/components/common/ImageSVG.vue'

export default {
  components: {
    'image-svg': ImageSVG
  },
  mixins: [NumberFormat, VDogHelper],
  props: {
    isSoccer: {
      type: Boolean,
      required: false
    }
  },
  methods: {
    toggleLeftMenu () {
      this.$emit('onToggleLeftMenu')
    }
  },
  computed: {
    closeImage: function () {
      return this.isSoccer ? 'close' : 'close-app'
    },
    logoClass: function () {
      return this.isSoccer ? 'a-vs-c-logo' : 'a-vg-c--logo'
    },
    closeButtonClass: function () {
      return this.isSoccer ? 'a-vs-c-mobile-close' : 'a-vg-c--mobile-close'
    },
    iconClass: function () {
      return this.isSoccer ? 'a-vs-icon' : 'a-vg-icon'
    }
  }
}
</script>
